module.exports = __webpack_public_path__ + "static/media/JPG.e8877e1a.svg";